"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/message/style");
var _message2 = _interopRequireDefault(require("antd/lib/message"));
var _react = _interopRequireWildcard(require("react"));
require("./style.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _Login = _interopRequireDefault(require("../Login"));
var _accountNetSdk = require("account-net-sdk");
var _consts = require("../../consts");
var _header = require("../../consts/header");
var _login = require("../../servers/login");
var _index = _interopRequireDefault(require("../AgreementModal/index"));
var _MergeLogin = _interopRequireDefault(require("../Login/MergeLogin"));
var _login2 = require("../../consts/login");
var _excluded = ["loginMode", "updateLogin", "updateAuth", "onlyWeGame", "onLoginSuccess"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var UserInfoModal = function UserInfoModal(props) {
  var updateAuth = props.updateAuth,
    isWeGame = props.isWeGame;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    accountInfo = _useState2[0],
    setAccountInfo = _useState2[1];
  // 显示
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    errorNum = _useState4[0],
    setErrorNum = _useState4[1];
  /**
   * 处理手机认证信息和乾坤锁
   */
  var handleInit = function handleInit() {
    (0, _login.getAccountInfo)().then(function (res) {
      if (!res.success) {
        _message2.default.error('获取信息失败');
        return;
      }
      setAccountInfo(res.data);
      var _res$data = res.data,
        eKeyStatus = _res$data.eKeyStatus,
        authStatus = _res$data.authStatus;
      var cnt = 0;
      if (!eKeyStatus) {
        cnt++;
      }
      if (authStatus === _header.MOBILE_STATUS.unbind) {
        cnt++;
      }
      setErrorNum(cnt);
    });
  };
  var btnStatus = function btnStatus() {
    var authStatus = accountInfo.authStatus,
      accountType = accountInfo.accountType;
    if (authStatus === _header.MOBILE_STATUS.unbind) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: _header.UNBIND_URL,
        target: "_blank"
      }, "\u7ED1\u5B9A");
    } else if (authStatus === _header.MOBILE_STATUS.bind) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
        href: _header.BIND_VERIFY_URL,
        target: "_blank"
      }, "\u8BA4\u8BC1"), /*#__PURE__*/_react.default.createElement("a", {
        href: _header.BIND_CHANGE_URL,
        target: "_blank"
      }, "\u66F4\u6362"), /*#__PURE__*/_react.default.createElement("a", {
        href: _header.UNBIND_PHONE_URL,
        target: "_blank"
      }, "\u89E3\u7ED1"));
    } else if (authStatus === _header.MOBILE_STATUS.authing) {
      return /*#__PURE__*/_react.default.createElement("span", null, "\u8FD8\u5DEE", /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('day')
      }, 30 - accountInfo.authDays), "\u5929\u901A\u8FC7\u9A8C\u8BC1");
    } else if (accountType === _header.ACCOUNT_TYPE) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: _header.BIND_CHANGE_URL,
        target: "_blank"
      }, "\u66F4\u6362\u624B\u673A");
    }
  };
  (0, _react.useEffect)(function () {
    if (!isWeGame) {
      handleInit();
    }
  }, [updateAuth]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_info_modal"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_user_icon_wrap"
  }, ' ', /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_user_icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_user_wrap', {
      gy_wrap_loading: !accountInfo.authStatus && !accountInfo.eKeyStatus
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_user_title')
  }, errorNum === 0 ? "\u60A8\u7684\u8D26\u53F7\u5B89\u5168\u72B6\u6001\uFF1A" : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "\u60A8\u7684\u8D26\u53F7\u5B58\u5728", /*#__PURE__*/_react.default.createElement("span", {
    className: "num"
  }, errorNum), "\u9879\u98CE\u9669\uFF1A")), /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames.default)('gy_user_content')
  }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)('gy_user_icon_mobile', {
      gy_user_icon_error: accountInfo.authStatus === _header.MOBILE_STATUS.unbind
    })
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_name')
  }, "\u624B\u673A\u8BA4\u8BC1\uFF1A"), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_status')
  }, accountInfo.authStatus === _header.MOBILE_STATUS.authFinish ? accountInfo.bindPhone : _header.MOBILE_STATUS_MAP[accountInfo.authStatus]), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_info')
  }, btnStatus())), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)('gy_user_icon_lock', {
      // gy_user_icon_lock_error: clockData.status === MOBILE_STATUS.unbind,
      gy_user_icon_lock_error: !accountInfo.eKeyStatus
    })
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_name')
  }, "\u5149\u5B87\u4E7E\u5764\u9501\uFF1A"), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_status')
  }, accountInfo.eKeyStatus ? '已绑定' : '尚未开通'), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('gy_user_opera_info')
  }, !accountInfo.eKeyStatus && /*#__PURE__*/_react.default.createElement("a", {
    href: _header.LOCK_UNBIND_URL,
    target: "_blank"
  }, "\u7ED1\u5B9A"), accountInfo.eKeyStatus && /*#__PURE__*/_react.default.createElement("a", {
    href: _header.LOCK_BIND_URL,
    target: "_blank"
  }, "\u4E7E\u5764\u9501\u7BA1\u7406"))))));
};
var LoginStatusMenu = function LoginStatusMenu(props) {
  var isLogin = props.isLogin,
    username = props.username,
    loginMode = props.loginMode,
    handleLoginClick = props.handleLoginClick,
    updateAuth = props.updateAuth;
  /**
   * 退出登录
   */
  var handleLoginOut = function handleLoginOut() {
    var isWeGame = loginMode === _login2.LOGIN_TYPE_MAP.MERGE && (0, _login2.getLoginType)();
    (0, _login.loginOut)({
      isWeGame: isWeGame
    }).then(function (res) {
      if (res && res.success) {
        window.location.reload();
      }
    });
  };
  return isLogin ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_header_menu_name', {
      gy_header_we_game_menu: (0, _login2.getLoginType)()
    }),
    id: "gy_header_menu_name"
  }, "\u60A8\u597D\uFF0C", /*#__PURE__*/_react.default.createElement("a", {
    href: loginMode === _login2.LOGIN_TYPE_MAP.MERGE ? _consts.WE_GAME_URL : _consts.ACCOUNT_URL,
    target: "_blank",
    className: "gy_header_username"
  }, username), /*#__PURE__*/_react.default.createElement(UserInfoModal, {
    updateAuth: updateAuth,
    isWeGame: loginMode === _login2.LOGIN_TYPE_MAP.MERGE && (0, _login2.getLoginType)()
  })), /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_header_line"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_loginOut",
    id: "gy_header_menu_loginOut",
    onClick: handleLoginOut
  }, "\u9000\u51FA")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_login",
    id: "gy_header_menu_login",
    onClick: function onClick() {
      return handleLoginClick();
    }
  }, "\u767B\u5F55"), loginMode === _login2.LOGIN_TYPE_MAP.DEFAULT && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("i", {
    className: "gy_header_line"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_header_menu_register",
    id: "gy_header_menu_register"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _consts.REGISTER_URL,
    target: "_blank"
  }, "\u6CE8\u518C"))));
};
var Header = function Header(props) {
  var _props$loginMode = props.loginMode,
    loginMode = _props$loginMode === void 0 ? 'DefaultLogin' : _props$loginMode,
    updateLogin = props.updateLogin,
    updateAuth = props.updateAuth,
    _props$onlyWeGame = props.onlyWeGame,
    onlyWeGame = _props$onlyWeGame === void 0 ? false : _props$onlyWeGame,
    onLoginSuccess = props.onLoginSuccess,
    ret = _objectWithoutProperties(props, _excluded);
  // 显示登录弹窗
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalVisible = _useState6[0],
    setModalVisible = _useState6[1];
  // 显示合并登录弹窗
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    mergeModalVisible = _useState8[0],
    setMergeModalVisible = _useState8[1];
  // 合并登录类型
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    loginType = _useState10[0],
    setLoginType = _useState10[1];
  // 是否登录
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLogin = _useState12[0],
    setIsLogin = _useState12[1];
  // 显示协议
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    showAgreement = _useState14[0],
    setShowAgreement = _useState14[1];
  // 用户名
  var _useState15 = (0, _react.useState)(''),
    _useState16 = _slicedToArray(_useState15, 2),
    username = _useState16[0],
    setUsername = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isWeGame = _useState18[0],
    setIsWeGame = _useState18[1];
  /**
   * 登录状态
   * @param type
   */
  var handleLoginStatus = function handleLoginStatus() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'init';
    var isWeGame = loginMode === _login2.LOGIN_TYPE_MAP.MERGE && (0, _login2.getLoginType)() || onlyWeGame;
    setIsWeGame(isWeGame);
    (0, _accountNetSdk.LoginStatus)(isWeGame).then(function (res) {
      props.onLoginStatus && props.onLoginStatus(_objectSpread(_objectSpread({}, res), {}, {
        isWeGame: isWeGame
      }));
      if (!res.isSuccess && res.message == '请登录' || res.message == '登录过期') {
        if (updateLogin === null || updateLogin === void 0 ? void 0 : updateLogin.visibleLogin) {
          handleLoginClick();
        }
        setIsLogin(false);
        return;
      }
      // 协议
      if (!res.agreeStatus) {
        setShowAgreement(true);
      }
      if (type === 'init' && res.isLogin) {
        //登录状态还在
        setIsLogin(true);
        setUsername(res.account);
      }
    });
  };
  /**
   * 登录成功回调
   */
  var onSuccess = function onSuccess(props) {
    onLoginSuccess === null || onLoginSuccess === void 0 ? void 0 : onLoginSuccess(props);
    setIsLogin(true);
    setModalVisible(false);
    setUsername(props.maskAccount);
    handleLoginStatus('refresh');
    if (props.type === 'qrcode') {
      window.location.reload();
    }
  };
  var onError = function onError(res) {
    // if (res.error === LOGIN_STATUS.IMPERFECT) {
    //   const { uuid, account } = res.data;
    //   let url = `${ACCOUNT_UI_URL}/adultValidate?uuid=${uuid}&account=${account}`;
    //   setIncompleteInfo(url);
    // }
    props.onLoginError && props.onLoginError(res);
  };
  var onClose = function onClose() {
    setModalVisible(false);
  };
  var handleLoginClick = function handleLoginClick() {
    if (loginMode === _login2.LOGIN_TYPE_MAP.DEFAULT) {
      setModalVisible(true);
    } else if (loginMode === _login2.LOGIN_TYPE_MAP.MERGE) {
      setMergeModalVisible(true);
    }
  };
  var handleLoginClose = function handleLoginClose() {
    setMergeModalVisible(false);
  };
  var handleTypeClick = function handleTypeClick(type) {
    setLoginType(type);
    if (type === _login2.MERGE_LOGIN_TYPE.GY) {
      setModalVisible(true);
      setMergeModalVisible(false);
    }
  };
  (0, _react.useEffect)(function () {
    handleLoginStatus();
    (0, _login.getConfigPage)().then(function (res) {
      if (res.data) {
        document.documentElement.style.filter = 'grayscale(100%)';
      }
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (updateLogin && Object.keys(updateLogin).length) {
      handleLoginStatus();
    }
  }, [updateLogin]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_wrap"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_layout"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_logo"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _consts.LOGO_URL,
    alt: "\u5149\u5B87\u6E38\u620F"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_common_menu"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_header_menu_home",
    id: "btn_header_menu_home",
    href: isWeGame ? _consts.WE_GAME_URL : _consts.GYYX_URL
  }, "\u9996\u9875")), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_info_menu"
  }, loginMode === _login2.LOGIN_TYPE_MAP.DEFAULT && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_game"
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: "btn_header_game"
  }, "\u6E38\u620F\u670D\u52A1"), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_game_service"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_header_game_content",
    id: "btn_header_game_content"
  }, "\u6E38\u620F\u670D\u52A1\uFF1A", _header.SERVICE_DATA.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.url,
      target: "_blank"
    }, item.title));
  })))), /*#__PURE__*/_react.default.createElement(LoginStatusMenu, {
    isLogin: isLogin,
    username: username,
    handleLoginClick: handleLoginClick,
    loginType: loginType,
    loginMode: loginMode,
    updateAuth: updateAuth
  }))), modalVisible && /*#__PURE__*/_react.default.createElement(_Login.default, _objectSpread({
    onSuccess: onSuccess,
    onClose: onClose,
    onError: onError
  }, ret)), showAgreement && /*#__PURE__*/_react.default.createElement(_index.default, {
    onClose: setShowAgreement,
    loginMode: loginMode
  }), mergeModalVisible && /*#__PURE__*/_react.default.createElement(_MergeLogin.default, _objectSpread({
    onClose: handleLoginClose,
    onTypeClick: handleTypeClick
  }, ret)));
};
var _default = Header;
exports.default = _default;